const removeTimezoneFromTime = (dateRaw, mutable = true) => {
  const date = mutable ? dateRaw : new Date(dateRaw);
  date.setTime(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return date;
};

export default removeTimezoneFromTime;
